import React from "react";
import { Container, Typography, Toolbar, AppBar, Box, Divider } from "@mui/material";
import Atras from "./atras";
import BottomNav from "./BottomNav";

const sections = [
  {
    title: "1. Aceptación de los términos",
    body: "Al registrarse y utilizar FindMe, usted acepta quedar vinculado por estos Términos y Condiciones. Si no está de acuerdo con alguna parte de estos términos, no podrá utilizar el servicio. El uso continuado de la aplicación implica la aceptación de cualquier modificación futura.",
  },
  {
    title: "2. Descripción del servicio",
    body: "FindMe es una plataforma de geolocalización profesional que permite a usuarios registrados compartir su ubicación en tiempo real, crear perfiles profesionales y conectar con otros profesionales cercanos. El servicio se ofrece a través de aplicación móvil y web.",
  },
  {
    title: "3. Registro y cuenta de usuario",
    body: "Para utilizar FindMe debe registrarse con información veraz y actualizada. Usted es responsable de mantener la confidencialidad de sus credenciales de acceso y de todas las actividades que ocurran bajo su cuenta. Debe notificarnos de inmediato cualquier uso no autorizado de su cuenta.",
  },
  {
    title: "4. Uso aceptable",
    body: "Usted se compromete a utilizar FindMe únicamente con fines legales y profesionales. Está prohibido: (a) publicar información falsa o engañosa; (b) acosar, intimidar o amenazar a otros usuarios; (c) intentar acceder a cuentas ajenas; (d) usar el servicio para actividades ilícitas; (e) publicar contenido ofensivo, discriminatorio o inapropiado.",
  },
  {
    title: "5. Ubicación y privacidad",
    body: "Al activar la funcionalidad de mapa, usted consiente compartir su ubicación en tiempo real con otros usuarios de FindMe. Puede desactivar esta función cerrando sesión o revocando los permisos de ubicación en su dispositivo. FindMe no se responsabiliza por el uso indebido que otros usuarios hagan de la información de ubicación visible en la plataforma.",
  },
  {
    title: "6. Contenido del usuario",
    body: "Usted es el único responsable del contenido que publica en FindMe, incluyendo fotos de perfil, información profesional y mensajes. Al publicar contenido, nos otorga una licencia no exclusiva para mostrarlo dentro de la plataforma. Nos reservamos el derecho de eliminar contenido que viole estos términos.",
  },
  {
    title: "7. Propiedad intelectual",
    body: "Todos los derechos de propiedad intelectual sobre FindMe, incluyendo su diseño, código fuente, logotipos y marca, son propiedad exclusiva de FindMe. Queda prohibida su reproducción, distribución o modificación sin autorización expresa por escrito.",
  },
  {
    title: "8. Limitación de responsabilidad",
    body: "FindMe se proporciona 'tal como está'. No garantizamos la disponibilidad ininterrumpida del servicio ni la exactitud de la información proporcionada por terceros usuarios. En ningún caso seremos responsables de daños indirectos, incidentales o consecuentes derivados del uso o la imposibilidad de uso del servicio.",
  },
  {
    title: "9. Modificaciones del servicio",
    body: "Nos reservamos el derecho de modificar, suspender o discontinuar cualquier parte del servicio en cualquier momento, con o sin previo aviso. También podemos actualizar estos Términos y Condiciones; los cambios entrarán en vigencia desde su publicación en la aplicación.",
  },
  {
    title: "10. Cancelación de cuenta",
    body: "Usted puede cancelar su cuenta en cualquier momento desde la configuración de la aplicación. Nos reservamos el derecho de suspender o eliminar cuentas que violen estos términos, sin previo aviso y sin responsabilidad alguna.",
  },
  {
    title: "11. Ley aplicable",
    body: "Estos Términos y Condiciones se rigen por las leyes de la República Argentina. Cualquier disputa que pudiera surgir será sometida a la jurisdicción de los tribunales ordinarios competentes.",
  },
  {
    title: "12. Contacto",
    body: "Para consultas sobre estos Términos y Condiciones, puede contactarnos en: soporte@findme.app",
  },
];

const Terms = () => {
  return (
    <Container maxWidth="md">
      <AppBar position="fixed" elevation={0} sx={{ background: "rgba(8,11,20,0.88)", backdropFilter: "blur(24px)", WebkitBackdropFilter: "blur(24px)", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
        <Toolbar sx={{ flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "10px" }}>
          <Atras color="inherit" />
          <Container sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", width: "100%", height: "90px", marginTop: "10px" }}>
            <Typography variant="h5" color="white" gutterBottom>
              Términos y Condiciones
            </Typography>
          </Container>
        </Toolbar>
      </AppBar>
      <Box sx={{ mt: "140px", mb: 14, px: 1 }}>
        <Box sx={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 4, p: 3, mb: 3 }}>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.55)", fontStyle: "italic" }}>
            Última actualización: marzo de 2026
          </Typography>
          <Typography variant="body1" sx={{ color: "rgba(185,205,255,0.8)", mt: 1, lineHeight: 1.8 }}>
            Bienvenido a FindMe. Lea atentamente estos Términos y Condiciones antes de utilizar nuestra aplicación. Al acceder o utilizar el servicio, usted acepta quedar obligado por estos términos.
          </Typography>
        </Box>
        {sections.map((s, i) => (
          <Box key={i} sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#00d4ff", mb: 0.8 }}>
              {s.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(185,205,255,0.75)", lineHeight: 1.9 }}>
              {s.body}
            </Typography>
            {i < sections.length - 1 && <Divider sx={{ mt: 2.5, borderColor: "rgba(255,255,255,0.06)" }} />}
          </Box>
        ))}
      </Box>
      <BottomNav />
    </Container>
  );
};

export default Terms;
